import { createMqStyles, tokens } from '@fhs/ui';

export const useEmptyStateMqStyles = createMqStyles({
  wrapper: {
    $base: {
      alignItems: 'center',
      gap: 8,
      padding: 32,
    },
  },
  title: {
    $base: {
      textAlign: 'center',
    },
  },
  body: {
    $base: {
      color: tokens.colors.$blackOpacity55,
      textAlign: 'center',
    },
  },
  link: {
    $base: {
      color: tokens.colors.$houseRed,
      textDecorationLine: 'underline',
    },
  },
});
